import React from "react"
import logo from "../../assets/images/logo/rh-white.svg"

const HackawayLogoText = props => <img {...props} src={logo} />

export { HackawayLogoText }
